import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, timeout } from 'rxjs';
import { environment } from 'src/environments/environment';
import { nombreArchivoDeCabecera } from './domiciliacion-aceptaciones.logica';

/**
 * Aceptación de términos de domiciliación por cuenta (la vieja de Grupo Total y la nueva de CrediTotal).
 * Ambas rutas piden `contactos.domiciliacion.descargar_aceptacion`; sin él el núcleo responde 403.
 * El token lo agrega el interceptor de autenticación.
 */
@Injectable({
  providedIn: 'root'
})
export class DomiciliacionAceptacionesService {
  private env: any = environment;
  private baseUrl: string = this.env.BASE_LA;

  constructor(private http: HttpClient) {}

  /** Aceptaciones del cliente (ascendente por fecha). Si falla (403 incluido), devuelve []. */
  async listar(personCode: string): Promise<any[]> {
    try {
      const r: any = await lastValueFrom(
        this.http.get<any>(`${this.baseUrl}/api/domiciliacion-aceptaciones/${encodeURIComponent(personCode)}`).pipe(timeout(20000))
      );
      return r?.success && Array.isArray(r.aceptaciones) ? r.aceptaciones : [];
    } catch (e) {
      return [];
    }
  }

  /** Baja el PDF y lo guarda con el nombre del `Content-Disposition` (respaldo: aceptacion-domiciliacion.pdf). */
  async descargar(personCode: string, id: string): Promise<void> {
    const resp = await lastValueFrom(
      this.http.get(`${this.baseUrl}/api/domiciliacion-aceptaciones/${encodeURIComponent(personCode)}/${encodeURIComponent(id)}/pdf`, {
        responseType: 'blob',
        observe: 'response'
      }).pipe(timeout(60000))
    );
    const nombre = nombreArchivoDeCabecera(resp.headers.get('Content-Disposition'));
    const url = window.URL.createObjectURL(resp.body as Blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = nombre;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
}
